import { IonContent, IonPage } from '@ionic/react'
import React from 'react'
import Header from '../components/Header'
import './HelpCenter.css'
interface HelpItemProps {
    title?: string
    desc?: string
}
const HelpItem: React.FC<HelpItemProps> = (props) => {
    return (
        <div className='help-item'>
            <p className='help-item__title'>{props.title}</p>
            <p className='help-item__desc'>{props.desc}</p>
        </div>
    )
}
const HelpCenter: React.FC = () => {
    return (
        <IonPage>
            <IonContent className='help-center-content'>
                <Header title='帮助中心' />
                <HelpItem
                    title='输入“帮助”命令'
                    desc='可以查阅用户使用文档以及所有命令汇总'
                />
                <HelpItem
                    title='输入“配置”命令'
                    desc='可以对知识和机器人进行配置'
                />
                <HelpItem title='输入“学习”' desc='可以让机器人持续学习' />
            </IonContent>
        </IonPage>
    )
}

export default HelpCenter
